import {getRedirectDomain} from "./getRedirectDomain";

export const setDatasets = (e:Event) => {
	const target = e.currentTarget as HTMLInputElement;
	const value = target.value;
	const emailDatasets = document.querySelectorAll('[data-inner-text-email]');
	if(!(emailDatasets.length > 0)) return
	emailDatasets.forEach(elem => {
		elem.innerHTML = value.trim();
	})

	const emailDomainDatasets = document.querySelectorAll('[data-inner-text-email-domain]');
	if(!(emailDatasets.length > 0)) return
	emailDomainDatasets.forEach(elem => {
		elem.innerHTML = getRedirectDomain(value.trim());
	})

	const buttonDatasets = document.querySelectorAll('[data-dset-domain]') as NodeListOf<HTMLButtonElement>;
	if(!(buttonDatasets.length > 0)) return
	buttonDatasets.forEach(elem => {
		elem.dataset.dsetDomain = getRedirectDomain(value.trim());
	})
}
